import React from "react";
import {PageHeading} from "peggirkit";
import {generateBreadcrumbs} from "../../../layout/Breadcrumbs";
import {Route} from "@/routing/Router";
import {FormattedMessage, useIntl} from "react-intl";
import FeaturedProductsHeadingActions from "@widgets/featuredProducts/overview/heading/FeaturedProductsHeadingActions";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";

type Props = {
    route: Route,
};

const FeaturedProductsHeading = ({route}: Props) => {
    const intl = useIntl();

    return (
        <div className={"flex flex-col gap-4"}>
            <PageHeading
                breadcrumbs={generateBreadcrumbs(route, intl)}
                title={intl.formatMessage(({id: "featuredProducts"}))}
                actionRowHorizontal={false}
                actionRow={<FeaturedProductsHeadingActions/>}
                meta={<LocationPageMeta/>}
                breakpoints={{md: {actionRowHorizontal: true}}}
            />

            <p className={"w-full text-sm max-w-[600px] text-gray-500 dark:text-slate-400"}>
                <FormattedMessage id={"featuredProductsExplanation"}/>
            </p>
        </div>
    );
};

export default FeaturedProductsHeading;